import React from 'react';
import pt from 'prop-types';

import { Typography } from '@metarouter-private/mr-mui';
import { AceDiffViewer } from '@ion/components';

import transformRevisionForDiff from './transformRevisionForDiff';

export default function RevisionDiffViewer({ integration, leftPlaybook, rightPlaybook }) {
  if (leftPlaybook.id === rightPlaybook.id) {
    return (
      <Typography variant="body2" color="secondary">
        The selected revisions are identical.
      </Typography>
    );
  }

  const leftTransformed = transformRevisionForDiff({ playbook: leftPlaybook, integration });
  const rightTransformed = transformRevisionForDiff({ playbook: rightPlaybook, integration });

  return (
    <AceDiffViewer
      lang="json"
      collapseUnchanged
      foldable
      oldValue={JSON.stringify(leftTransformed, null, 2)}
      newValue={JSON.stringify(rightTransformed, null, 2)}
      leftTitle={<Typography variant="subtitle1">Revision {leftPlaybook.revision}</Typography>}
      rightTitle={<Typography variant="subtitle1">Revision {rightPlaybook.revision}</Typography>}
    />
  );
}

RevisionDiffViewer.propTypes = {
  integration: pt.object.isRequired,
  leftPlaybook: pt.object.isRequired,
  rightPlaybook: pt.object.isRequired,
};
